var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"threecontainer"},[_c('ThreeViewer',{attrs:{"showTileGrid":false,"tileRadius":2000,"useControls":true,"shortCode":_vm.shortCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }